import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { useState, useEffect } from "react";
import "./Header.css";
import Aside from "./Aside";
import AccountPopover from "../global/AccountPopOver";
import secureLocalStorage from "react-secure-storage";

const Header = ({ disappearNavlink, disappearRegister }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [role, setRole] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [loading, setLoading] = useState(false); // State for loading progress

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    setRole(userRole);

    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);

    // Event listeners for loading progress
    window.addEventListener("beforeunload", startLoading);
    window.addEventListener("load", stopLoading);

    return () => {
      window.removeEventListener("beforeunload", startLoading);
      window.removeEventListener("load", stopLoading);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const smoothScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLoginClick = () => {
    setLoading(true); // Set loading state to true when login logo is clicked
  };

  return (
    <div className={`nav-wrapper ${scrollPosition > 0 ? "scrolled" : ""}`}>
      <header className={`navbar ${scrollPosition > 0 ? "scrolled" : ""}`}>
        {loading && <div id="progress-bar" />}{" "}
        {/* Display progress bar when loading */}
        <div className="hamburger-frame">
          {role != "admin" && (
            <div className="hamburger" onClick={toggleMenu}>
              <div className="link3">
                <div className="divheader-bar-icon">
                  <div className="span1" />
                  <div className="span2" />
                  <div className="span3" />
                  <div className="span4" />
                </div>
              </div>
            </div>
          )}
          <div className="logo-title-frame cursor-hidden">
            <Link to="/" onClick={handleLoginClick}>
              {/* Add onClick event for login logo */}
              <img className="project-logo" alt="" src="/project-logo.png" />
            </Link>
            <h3 className="project-name">Forex Miner</h3>
          </div>
        </div>
        <div className="nav-menu-items">
          {role != "admin" &&
            (disappearNavlink == true ? null : (
              <>
                <a className="link" onClick={() => smoothScrollTo("hero")}>
                  Home
                </a>
                <a className="link" onClick={() => smoothScrollTo("packages")}>
                  Packages
                </a>
                <a className="link" onClick={() => smoothScrollTo("faq")}>
                  Faq
                </a>
                <a className="link" onClick={() => smoothScrollTo("contact")}>
                  Contact Us
                </a>
              </>
            ))}
        </div>
        {disappearRegister ? null : role == null || role === undefined ? (
          <Link className="login-frame" to="/signin" onClick={handleLoginClick}>
            {/* Add onClick event for login */}
            <div className="custom-circle">
              <img className="mask-group-icon1" alt="" src="/loginIcon.png" />
            </div>
          </Link>
        ) : (
          <AccountPopover role={role} />
        )}
      </header>
      {menuOpen && <Aside />}
    </div>
  );
};

export default Header;
